import Vue from 'vue'
import Vuex from 'vuex'
import {user} from './modules/user'
import {bot} from './modules/bot'
import {core} from './modules/core'
import {cards} from './modules/cards'
import blocksBuild from './modules/blocks-build'
import {settings} from "./modules/settings";
import nlp from "./modules/nlp/index";
import {chatHistory} from "./modules/chat-history"
import {broadcasts} from "./modules/broadcast"
import {campaigns} from "./modules/campaign"

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    bot,
    core,
    blocksBuild,
    cards,
    nlp,
    settings,
    chatHistory,
    broadcasts,
    campaigns
  },
})

export default store
